
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getAnimationDelay(index: number, baseDelay: number = 0) {
  return `${(index * 150) + baseDelay}ms`;
}
